
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { postAddGameType } from '@/api/game-manage';
import { iSelectGameType } from '@/interface/game-manage';
@Component
export default class EditGame extends Vue {
  @Prop() visible!: Boolean;
  @Prop() flag?: Number;
  @Prop() model!: iSelectGameType;

  rules = {
    name: [{ required: true, message: '请输入游戏名称', trigger: 'blur' }],
  };

  submitForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.postNewGameType();
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  @Emit()
  close() {}
  async postNewGameType() {
    // console.log(this.model);
    // return;
    this.$msgbox({
      title: '提示',
      message: !this.flag ? '添加类别后,关闭可返回选择游戏类别' : '确认添加？',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          await postAddGameType(this.model);
          done();
          instance.confirmButtonLoading = false;
          this.$emit('close');
        } else if (action === 'cancel') {
          instance.confirmButtonLoading = false;
          done();
        }
      },
    })
      .then(() => {
        // done();
      })
      .catch((err: any) => {
        console.log(err, 'postNewGameType');
      });
  }
}
